export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      // ========== 사업장(직접수행)
      {
        path: "ep-field/workplace",
        name: "ep-field-workplace-list",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_EP/FieldWorkplaceList.vue"),
      },
      {
        path: "ep-field/workplace/write",
        name: "ep-field-workplace-create",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_EP/FieldWorkplaceWrite.vue"),
      },
      {
        path: "ep-field/workplace/write/:postId",
        name: "ep-field-workplace-update",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_EP/FieldWorkplaceWrite.vue"),
      },
      {
        path: "ep-field/workplace/info",
        name: "ep-field-workplace-info",
        meta: {
          activeCode: "field-workplace",
        },
        component: () => import("@/views/_EP/FieldWorkplaceInfo.vue"),
      },

      // ========== 사업장(용역위탁)
      {
        path: "ep-field/workplace2",
        name: "ep-field-workplace2-list",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_EP/FieldWorkplace2List.vue"),
      },
      {
        path: "ep-field/workplace2/write",
        name: "ep-field-workplace2-create",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_EP/FieldWorkplace2Write.vue"),
      },
      {
        path: "ep-field/workplace2/write/:postId",
        name: "ep-field-workplace2-update",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_EP/FieldWorkplace2Write.vue"),
      },
      {
        path: "ep-field/workplace2/info",
        name: "ep-field-workplace2-info",
        meta: {
          activeCode: "field-workplace2",
        },
        component: () => import("@/views/_EP/FieldWorkplace2Info.vue"),
      },

      // ========== 시설물
      {
        path: "ep-field/facility",
        name: "ep-field-facility-list",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_EP/FieldFacilityList.vue"),
      },
      {
        path: "ep-field/facility/write",
        name: "ep-field-facility-create",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_EP/FieldFacilityWrite.vue"),
      },
      {
        path: "ep-field/facility/write/:postId",
        name: "ep-field-facility-update",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_EP/FieldFacilityWrite.vue"),
      },
      {
        path: "ep-field/facility/info",
        name: "ep-field-facility-info",
        meta: {
          activeCode: "field-facility",
        },
        component: () => import("@/views/_EP/FieldFacilityInfo.vue"),
      },

      // ========== 발주 사업장
      {
        path: "ep-field/field",
        name: "ep-field-field-list",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_EP/FieldFieldList.vue"),
      },
      {
        path: "ep-field/field/write",
        name: "ep-field-field-create",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_EP/FieldFieldWrite.vue"),
      },
      {
        path: "ep-field/field/write/:postId",
        name: "ep-field-field-update",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_EP/FieldFieldWrite.vue"),
      },
      {
        path: "ep-field/field/info",
        name: "ep-field-field-info",
        meta: {
          activeCode: "field-field",
        },
        component: () => import("@/views/_EP/FieldFieldInfo.vue"),
      },

      // ==========
      {
        path: "company/info",
        name: "company-info",
        meta: {
          activeCode: "company-info",
        },
        component: () => import("@/views/_EP/CompanyInfo.vue"),
      },

      // ========== 자료실 ============
      {
        path: "filelibrary/320",
        name: "filelibrary-320",
        meta: {
          activeCode: "filelibrary-320",
          boardId: 320,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/321",
        name: "filelibrary-321",
        meta: {
          activeCode: "filelibrary-321",
          boardId: 321,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/322",
        name: "filelibrary-322",
        meta: {
          activeCode: "filelibrary-322",
          boardId: 322,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/323",
        name: "filelibrary-323",
        meta: {
          activeCode: "filelibrary-323",
          boardId: 323,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/324",
        name: "filelibrary-324",
        meta: {
          activeCode: "filelibrary-324",
          boardId: 324,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/325",
        name: "filelibrary-325",
        meta: {
          activeCode: "filelibrary-325",
          boardId: 325,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/340",
        name: "filelibrary-340",
        meta: {
          activeCode: "filelibrary-340",
          boardId: 340,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/341",
        name: "filelibrary-341",
        meta: {
          activeCode: "filelibrary-341",
          boardId: 341,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/342",
        name: "filelibrary-342",
        meta: {
          activeCode: "filelibrary-342",
          boardId: 342,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/343",
        name: "filelibrary-343",
        meta: {
          activeCode: "filelibrary-343",
          boardId: 343,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/347",
        name: "filelibrary-347",
        meta: {
          activeCode: "filelibrary-347",
          boardId: 347,
        },
        component: () => import("@/views/_EP/FileLibraryList.vue"),
      },
    ],
  },
];
